var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"title":"Admin Requirment","fields":_vm.fields,"response":_vm.response,"show_header_filter":false},on:{"delete":_vm.deleteRecord,"create":_vm.createRecord,"edit_click":_vm.editRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }